import React from 'react'
import "./example.scss"
import HealthPerformance from './sections/healthPerformance/indes'
import HealthSector from './sections/healthSector'
import RetailPerformance from './sections/retailPerformance'
import RetailSector from './sections/retailSector'
import SeeSomeOfThePerformance from './sections/seeSomeOfThePerformance'
import TelecomPerformance from './sections/telecomPerformance'
import TelecomSector from './sections/telecomSector'
import WantToKnowMore from './sections/wantToKnowMore'
import Letsgo from "../connectors/letsgo"

function Example() {
  return (
    <div className='container-example'>
      <div className="section-see-some-of-the-performance">
        <SeeSomeOfThePerformance />
      </div>
      <div className="section-telecom-performance">
        <TelecomPerformance />
      </div>
      <div className="section-telecom-sector">
        <TelecomSector />
      </div>
      <div className="section-health-performance">
        <HealthPerformance />
      </div>
      <div className="section-health-sector">
        <HealthSector />
      </div>
      <div className="section-retail-performance">
        <RetailPerformance />
      </div>
      <div className="section-retail-sector">
        <RetailSector />
      </div>
      <div className="section-want-to-know-more">
        <WantToKnowMore />
      </div>
      <div className="section-letsgo">
        <Letsgo />
      </div>
    </div>
  )
}

export default Example